import React, {useContext} from "react";
import S from "./CFTC.styled";
import FundContext from "@/components/FundSingle/FundProvider";
import generateFundComponentStructure from "../../FundComponentStructure";

const CurrentFundTabComponentsRenderer: React.FC = () => {

    const { currentTabIndex, fundRiskDetails } = useContext(FundContext);
    const { rows } = generateFundComponentStructure()[currentTabIndex];

    if (Object.keys(fundRiskDetails).length === 0) return <S.SpinnerWrapper><S.Spinner /></S.SpinnerWrapper>;

    return (
        <S.CFTCWrapper>
            <S.CFTCGrid>
                {rows && rows.map((row, rowIndex) => {
                    // Check if row is empty, or if all columns are null
                    if (row.every((column) => column === null)) return null;

                    return (
                        <S.CFTCRow key={rowIndex}>
                            {row.map((column, colIndex) => {
                                if (column === null) return '';
                                return (
                                    <S.CFTCCard key={colIndex}>{column}</S.CFTCCard>
                                )
                            })}
                        </S.CFTCRow>
                )})}
            </S.CFTCGrid>
        </S.CFTCWrapper>
    );
};

export default CurrentFundTabComponentsRenderer;
